import React, { memo } from "react";
import { useParams } from "react-router-dom";
import { PageTemplate } from "../../components/templates";
import { OUTPUT } from "../../enums";
import EnquadramentoAdd from "./_components/EnquadramentoAdd";

const ReportSettingsAdd = memo(() => {
  const params = useParams();

  return (
    <PageTemplate
      title={`Novo ${OUTPUT[params.output].descricao}`}
      subtitle={`${OUTPUT[params.output].descricao} / Configurações`}
      scrollable={false}
      maxWidth="md"
    >
      <EnquadramentoAdd />
    </PageTemplate>
  );
});

export default ReportSettingsAdd;
